<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Bread Request Additional Form
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click="save()"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-form>
        <b-row>
          <b-col md="3">
            <b-input-group>
              <b-input-group-append
                ><span class="input-group-text"
                  >Request Date</span
                ></b-input-group-append
              >
              <b-form-input
                v-model="model.orderdate"
                type="date"
                @change="tanggalBerubah"
                :state="!$v.model.orderdate.$error"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col md="3">
            <b-input-group>
              <!-- dibawah ini feature untuk memilih customer wholesale / retail -->
              <b-input-group-prepend v-if="!isEdit"
                ><label v-on:click.ctrl="generateQtyCustomer">Customer Group</label></b-input-group-prepend
              >
              <b-form-select
                v-model="model.customer_group"
                :options="custgroup"
                @change="reloaddata"
                v-if="!isEdit"
              ></b-form-select>
            </b-input-group>
          </b-col>
          <b-col md="3">
             <b-input-group class="p-2">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                    <b> {{ filterShow }}</b> Filter
                </b-form-checkbox>
             </b-input-group>
          </b-col>
        </b-row>
        <b-card no-body class="mb-1">
           <b-row v-if="(filterShow=='Hide')" class="mt-2">
              <b-col lg="4">
                  <b-form-group
                      label="Filter"
                      label-cols-sm="1"
                      label-size="sm"
                      label-for="filterInput"
                      class="mb-0"
                      >
                      <b-input-group size="sm">
                          <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                      </b-input-group>
                  </b-form-group>  
              </b-col> 
              <b-col lg="5">
                <b-form-group
                  label="Filter On"
                  label-cols-sm="1"
                  label-size="sm"
                  description="Leave all unchecked to filter on all data"
                  class="mb-0">
                  <b-form-checkbox-group v-model="filterOn" class="mt-1">
                    <b-form-checkbox value="itemname">Item Name</b-form-checkbox>
                    <b-form-checkbox value="vendor">Last Vendor</b-form-checkbox>
                    <!-- <b-form-checkbox value="createby">Issued By</b-form-checkbox> -->
                    <!-- <b-form-checkbox value="crewname">Employee Name</b-form-checkbox> -->
                  </b-form-checkbox-group>
                </b-form-group>                
              </b-col>                 
              <b-col lg="3">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                        <b> {{ filterShow }}</b> Filter
                      </b-form-checkbox>
              </b-col>         
          </b-row>
          <b-table-simple hover small responsive bordered sticky-header="500px">
            <b-thead head-variant="light">
              <b-tr>
                <b-th sticky-column style="min-width: 295px" variant="light"
                  >Item</b-th
                >
                <b-th
                  width="50px"
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  >{{ kol.CustName }}</b-th
                >
                <b-th style="text-align: right" width="80px" variant="success"
                  >TOTAL QTY REQUEST</b-th
                >
                <!-- <b-th style="text-align: right" width="100px" variant="success"
                  >Purc.Price</b-th
                >
                <b-th style="text-align: right" width="100px" variant="success"
                  >Amount</b-th
                > -->
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(row, idx) in ordLines.items" :key="row.itemno" :id="row.itemno">
                <b-th sticky-column>
                  <div style="display: inline-block; width: 295px">
                    <div style="width: 215px; font-weight: normal !important">
                      {{ idx + 1 }}. {{ row.itemname }}
                    </div>
                    <div
                      style="
                        float: right;
                        margin-top: -20px;
                        width: 80px;
                        text-align: right;
                        font-size: smaller;
                        font-weight: normal !important;
                      "
                    >
                      TOTAL QTY ADDITIONAL REQUEST: {{ row.quantity | numFormat }}
                    </div>

                  </div>
                </b-th>
                <b-td
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  style="padding: 0 !important"
                >
                  <input
                    type="number"
                    style="width: 100%; border: none"
                    :min="0"
                    v-model="row[`K${kol.CustCode}`]"
                    @change="calcTotQty(row)"
                    :key="`${row.podtlkey}${kol.CustCode}`"
                  />
                </b-td>
                <b-td style="text-align: right" variant="success">
                  {{ row.quantity | numFormat }}
                </b-td>
               
              </b-tr>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-th sticky-column style="min-width: 295px" variant="light"
                  >Total</b-th
                >
                <b-th
                  width="50px"
                  v-for="kol in customers"
                  :key="kol.CustCode"
                  class="text-right"
                  >{{ footLines[kol.CustCode] }}</b-th
                >
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-card>


        <b-row align-h="between" class="mt-1">
          <b-col offset="8" lg="4">
              <div class="text-right">
                  <b-input-group >
                      <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Qty Total</label></b-input-group-prepend>
                      <b-input-group-prepend>
                      </b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="model.ttlqty" disabled></my-number>
                  </b-input-group>
              </div>
          </b-col>
      </b-row>


      </b-form>
      <b-row class="justify-content-center mt-1">
        <div style="width: 300px">
          <b-input-group>
            <b-input-group-append>
              <button
                v-if="saveEnabled"
                class="btn btn-primary mr-1"
                @click="save()"
              >
                <i class="fa fa-save"></i> Save
              </button>
            </b-input-group-append>
            <b-input-group-append>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import procure from "../../apis/bakeryorder";
import customer from "../../apis/bakerycustomer";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      orderdate: { required },
      matauang: { required },
    },
  },
  data() {
    return {
      filterShow:'Hide',
      filter: '',
      filterOn: [],
      saveEnabled: true,
      isLoading: false,
      isEdit: false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuVendorShow: false,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      calcVAT: 1,
      calcuationVAT: [
        { value: 1, text: "VAT (Auto Calc)" },
        { value: 0, text: "VAT (Manual Calc)" },
      ],
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      lookupPPH: [],
      customers: [],
      items: [],
      itemprice: [],
      ordLines: {
        items: [],
      },
      footLines: [],
      custgroup: [{ value: "", text: "-- ALL--" }],
      model: {
        jasa: 0,
        orderdate: moment().format("YYYY-MM-DD"),
        requestno: "",
        ExpectRcv: "",
        remark: "",
        postgroup: "",
        typegroup: "OPEX",
        matauang: this.$store.state.user.matauang,
        compcode: this.$store.state.user.compcode,
        invterm: "COD",
        kodecash: "",
        terms: [],
        locationdeliv: this.$store.state.user.compaddr,
        ttlnetto: 0,
        nilaippn: 0,
        ttlamtdue: 0,
        ttlqty:0,
        customer_group: "",
        sortBy: "partnumber"
      },
      tabIndex: 0,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    if (
      // this.$route.params.requestkey &&
      // this.$route.params.customer_id &&
      this.$route.params.tgldelivery
    ) {
      toastr.info("Loading Order Detail, please wait");
      try {
        this.isEdit = true;
        this.isLoading = true;
        const [a, b, data, custgroup] = await Promise.all(
          [
            // procure.customeraktif(this.$route.params),
            procure.customerdistributionaktif(this.$route.params),
            procure.itemaktif(this.model),
            procure.detailrequestAdd(this.$route.params),
            customer.group()
          ],
        );
        this.model.orderdate = moment(this.$route.params.tgldelivery).format("YYYY-MM-DD");
        this.customers = a;
        this.items = b;
        if (custgroup) {
          custgroup.map((data) => {
            this.custgroup.push({
              value: data.value,
              text: data.text,
            });
          });
        }


        this.model.ttlqty = 0;
        let obj;
        this.items.forEach((item) => {
          const itemReqCollReduce =  data.filter(x=>x.itemno == item.itemno).reduce((ttl=0,data)=>{
            ttl += data.qtyOrder || 0;
            return ttl;
          },0);
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: itemReqCollReduce,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
          vendor:item.vendor||''
          // ,
          // createby:item.createby||''
        };
        this.model.ttlqty += itemReqCollReduce;
        this.ordLines.items.push(obj);
      });

        const row = data[0];
        row.tgldelivery = row.tgldelivery
          ? moment(row.tgldelivery).format("YYYY-MM-DD")
          : "";
        // row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
        for (var key in row) {
          this.model[key] = row[key];
        }
        if (row.tgldelivery < this.$store.state.user.tglaktif) {
          this.saveEnabled = false;
        }

        if(data.find(x=> x.send2wf==1)){
          this.saveEnabled = false;
        }
        
        for (let index = 0; index < data.length; index++) {
          const item = data[index];
          let findIdx_ = this.ordLines.items.findIndex((x) => x.itemno == item.itemno);
          if (findIdx_ > -1) {
              this.ordLines.items[findIdx_][`K${item.CustCode}`]= item.qtyOrder;
          }
        }
        this.ordLines.total = this.ordLines.items.length;
        this.calcTotalDtlOrder();
        this.tanggalBerubah();
        this.calcFootLines();
        toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.isLoading = true;
      this.model.orderdate = moment().format("YYYY-MM-DD");
      const [a, b, custgroup] = await Promise.all([
        // procure.customeraktif(),
        procure.customerdistributionaktif(),
        procure.itemaktif(this.model),
        customer.group(),
      ]);
      this.customers = a;
      this.items = b;
      if (custgroup) {
        custgroup.map((data) => {
          this.custgroup.push({
            value: data.value,
            text: data.text,
          });
        });
      }

      let obj;
      this.items.forEach((item) => {
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: 0,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
          vendor:item.vendor||''
          // ,
          // createby:item.createby||''
        };
        this.ordLines.items.push(obj);
      });
      // this.ordLines.items=b;
      this.ordLines.total = b.length;
      this.isLoading = false;
      let footLines = [];
      a.map((data) => {
        footLines[data.CustCode] = 0;
      });
      this.footLines = footLines;
    }
  },
  watch:{
    filterShow(val){
      console.log('filterShow',val);
    },
    filterOn (val){
      console.log('filterOn',val);
      this.onFiltered(this.filter)
    },
    filter(val){
      console.log('filter',val);
      this.onFiltered(val)
    },
  },
  methods: {
    generateQtyCustomer: function(){
        toastr.info('generate Customer Qty Order randomly');
            let obj;
            let orderprice;
            this.ordLines.items.forEach((item)=> {
                orderprice= this.itemprice.find(ip=>ip.itemno=item.itemno);
                if (orderprice) {
                    item.unitprice=orderprice.unitprice;
                }
                this.customers.forEach((kol)=> {
                    item[`K${kol.CustCode}`]=Math.floor(Math.random() * 11); 
                    item.quantity += item[`K${kol.CustCode}`];
                })

                this.calcPrice(item);
            });
            this.calcTotalDtlOrder();
    },
    onFiltered(filtertext) {
      let items = this.ordLines.items;
      this.filterOn.map((filter)=>{
        let ttl=0;
        let sum_=0;
        let footItems = [];
        
        items.map((item)=>{
          var result_style = document.getElementById(item.itemno).style;
          if (item[filter].toUpperCase().indexOf(filtertext.toUpperCase()) > -1) {
            result_style.display = '';
            ttl += item.quantity || 0;
            footItems.push(item);
          }else{
            result_style.display = 'none';
          }
        });
        this.model.ttlqty = ttl;

        let footLines = [];
        this.customers.map((data) => {
            const dtfilter = footItems.filter(x=>x[`K${data.CustCode}`]>0);
            const sum_ = dtfilter.reduce((ttl=0,dt)=>{
                ttl +=dt[`K${data.CustCode}`];
                return ttl;
            },0);
            footLines[data.CustCode] = sum_;
        });
        this.footLines = footLines;
      });
    },
    async reloaddata() {
      this.items = [];
      this.ordLines.items = [];
      this.isLoading = true;
      this.model.orderdate = moment(this.model.orderdate).format("YYYY-MM-DD");
      const [a, b] = await Promise.all([
        // procure.customeraktif(this.model),
        procure.customerdistributionaktif(this.model),
        procure.itemaktif(this.model),
      ]);
      this.customers = a;
      this.items = b;
      this.model.ttlqty = 0;
      let obj;
      this.items.forEach((item) => {
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: 0,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
          vendor:item.vendor||''
          // ,
          // createby:item.createby||''
        };
        this.ordLines.items.push(obj);
      });
      // this.ordLines.items=b;
      this.ordLines.total = b.length;
      this.isLoading = false;
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.isLoading = true;
          this.model.TableName = "po_header";

          // this.model.DimTableKey = diisi dari PR/SR;
          this.model.pohdrkey = this.model.pohdrkey || "";
          this.model.orderno = this.model.orderno || "";
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.terms = this.model.terms;
          row.orderdate = moment(row.orderdate).format("YYYY-MM-DD");
          row.expectreceipt = row.expectreceipt
            ? moment(row.expectreceipt).format("YYYY-MM-DD")
            : undefined;
          let lineno = 1;
          row.lines = this.ordLines.items.reduce((newArr, item) => {
            if ((item.itemno || "") != "") {
              item.lineno = lineno;
              newArr.push(item);
              lineno += 1;
            }
            return newArr;
          }, []);
          if (row.lines.length > 0) {
            await procure.saverequestAdditional(row);
            this.isLoading = false;
            toastr.success(`Success`, "Save Request Order", 10000);
            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              const tanggal = this.model.orderdate;
              this.model.ttlamtdue = 0;
              this.model.ttlnetto = 0;
              this.model.nilaippn = 0;
              const keys = ["ttlamtdue", "ttlnetto", "nilaippn"];
              for (var key in this.model) {
                if (keys.indexOf(key) == -1) {
                  this.model[key] = "";
                }
              }
              this.model.orderdate = tanggal;
              this.ordLines.items = [];
              this.ordLines.total = this.ordLines.items.length;
              this.calcTotalDtlOrder();
              this.$v.model.$reset();
            }
          } else {
            toastr.error(
              "Please fill at least 1(one) Order Detail",
              "ERROR MESSAGE"
            );
            this.saveEnabled = true;
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },

    calcFootLines(){
        let footLines = [];
        let ordLinesItem = this.ordLines.items;
            this.customers.map((data) => {
                const dtfilter = ordLinesItem.filter(x=>x[`K${data.CustCode}`]>0);
                const sum_ = dtfilter.reduce((ttl=0,dt)=>{
                    ttl +=dt[`K${data.CustCode}`];
                    return ttl;
                },0);
                footLines[data.CustCode] = sum_;
            });
            this.footLines = footLines;
    },

    calcTotQty: function (record) {
      setTimeout(() => {
        record.quantity = 0;
        this.customers.forEach((kol) => {
          record.quantity += parseFloat(record[`K${kol.CustCode}`] || 0);
        this.footLines[`${kol.CustCode}`] = this.ordLines.items.reduce(
          (ttl = 0, data) => {
            ttl += parseFloat(data[`K${kol.CustCode}`] ||0);
            return ttl;
          },
          0
        );
        });

        this.calcPrice(record);
        this.calcTotalDtlOrder();
      }, 100);
    },
    calcTotalDtlOrder: function () {
      this.calcVAT = this.calcVAT || 1;
      let nilaippn = 0;
      let ttlnetto = 0;
      let ttlqty = 0;
      let ttlamtdue = 0;
      // let totalpph = 0;
      let footLines_ = this.footLines;
      this.ordLines.items.forEach(function (trx) {
        if (trx.itemno) {
          ttlnetto += trx.nilai || 0;
          ttlqty += (trx.quantity || 0);
          nilaippn += trx.nilaippn || 0;
          ttlamtdue = ttlnetto + (nilaippn || 0);
          // totalpph += parseFloat(trx.nilaipph || 0);
        }
      });
      this.model.ttlnetto = ttlnetto;
      this.model.ttlqty = ttlqty;
      if (this.calcVAT == 1) {
        this.model.nilaippn = nilaippn;
      }
      this.model.ttlamtdue = ttlamtdue;
      // this.model.totalpph = totalpph;
      this.footLines = footLines_;
    },
    calcAmountDue: function () {
      this.model.ttlamtdue =
        parseFloat(this.model.ttlnetto || 0) +
        parseFloat(this.model.nilaippn || 0);
    },
    calcTaxes: function (record) {
      record.nilainett =
        parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
      record.dpp =
        (parseFloat(record.nilai) * parseFloat(record.dppnlain)) / 100;
      if (record.kenappn == 1) {
        record.ppn = record.ppn || 11;
      } else {
        // if ((record.ppn || 0) == 0 ) {
        // record.kenappn = 0;
        record.dpp = 0;
        record.ppn = 0;
      }
      // if (this.model.grossup == 1)
      //     record.dpp = record.dpp * (100 / (100 - record.pph));

      record.nilaippn = (parseFloat(record.ppn) / 100) * record.dpp;
      record.nilaidue = record.nilainett + record.nilaippn;
    },

    calcPrice: function (record) {
      // setTimeout(() => {
      record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
      record.disc = record.disc ? record.disc : 0;
      if (record.disc > 0) {
        record.nilaidisc = (record.disc * record.nilai) / 100.0;
      }
      // }, 100);
      // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
      this.calcTaxes(record);
    },
    calcPriceDelay: function (record) {
      const this_ = this;
      setTimeout(() => {
        record.nilai =
          parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
          record.nilaidisc = (record.disc * record.nilai) / 100.0;
        }
        this_.calcTotalDtlOrder();
      }, 100);
    },
    tanggalBerubah: function () {
      this.tahun = moment(this.model.tanggal).format("YYYY");
    },

    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "bakery.requestfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push("home");
      }
    },
  },
};
</script>
